import {AfterViewInit, Component,  OnDestroy, Input, OnInit} from '@angular/core';
import {StreamsService}  from "../../services/streams.service";
import {StreamProject, StreamAccessKey} from "../../interfaces";
import { ClipboardService } from 'ngx-clipboard'
import { NbGlobalPosition, NbDialogService, NbToastrService } from '@nebular/theme';
import {PanelVisibilityService} from '../../services/panel-visibility.service'
import {visibilityPanelAnimation} from '../../classes/visibility-panel.animation'

@Component({
  selector: 'app-stream-unlock-form-setting-control',
  templateUrl: './stream-unlock-form-setting-control.component.html',
  styleUrls: ['./stream-unlock-form-setting-control.component.scss'],
  animations: [visibilityPanelAnimation]
})
export class StreamUnlockFormSettingControlComponent implements OnInit, OnDestroy{
 

 
  @Input() stream: StreamProject

  loading:boolean = false

  text: any = ''
  button: any = ''
 
 subscribeSetForm$:any = null

   constructor(
    public streamsService: StreamsService,
    private _clipboardService: ClipboardService,
    private toastrService: NbToastrService,
    private dialogService: NbDialogService,
    public panelVisibility: PanelVisibilityService

    ){
  }
  


	save(){
	    
	    this.loading = true

		if( this.subscribeSetForm$){
	      this.subscribeSetForm$.unsubscribe()
	     }

	    this.subscribeSetForm$ = this.streamsService.updateUnlockForm(this.stream._id, this.text, this.button).subscribe((stream: StreamProject)=>{
	  
	      this.text  = stream.accessFormText || 'Введіть код'
	     this.button = stream.accessFormButton || 'Дивитися'

	 	 this.toastrService.show('','Налаштування збережені',{
			status: 'success',
			icon:'',
			position: <NbGlobalPosition>'bottom-right'
			  })

	      this.loading = false

	    },(error)=>{
	      this.loading = false
	  
	      this.toastrService.show('','Сталася помилка сервера',{
		status: 'danger',
		icon:'',
		position: <NbGlobalPosition>'bottom-right'
		  })
	    })


	  }


  ngOnInit() { 
   
	this.text = this.stream.accessFormText || 'Введіть код'
	this.button = this.stream.accessFormButton || 'Дивитися'
  }

  
   ngOnDestroy() {  
    if( this.subscribeSetForm$){
	      this.subscribeSetForm$.unsubscribe()
    }

   }
 

 

  
}
